export default __webpack_public_path__ + "static/6-298a261fa89d4c98b3a62ec69ebc9cae.webp";